import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { trackLeadConversion } from "../lib/gtag";

export default function Layout({ children }) {
  // Fire Google Ads "Submit lead form" conversion on any phone-call click
  useEffect(() => {
    const handler = (e) => {
      const anchor = e.target.closest && e.target.closest('a[href^="tel:"]');
      if (anchor) {
        trackLeadConversion();
      }
    };
    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white text-slate-900">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
